export const normalizePhoneValue = (value) => {
  if (value === null || value === undefined) return "";
  if (typeof value === "string" || typeof value === "number") {
    return String(value);
  }
  if (typeof value === "object") {
    return String(
      value.phone ||
      value.mobile ||
      value.value ||
      value.number ||
      ""
    );
  }
  return "";
};
